/**
 * PageContextProvider — Provides per-page context strings for the AI Coach.
 *
 * Each page calls setPageContext("...") to describe what the user is seeing.
 * The AI Coach widget reads this to give contextual, page-aware responses.
 */

import { createContext, useContext, useState, useCallback } from 'react';

const PageContext = createContext({
  pageContext: '',
  setPageContext: () => {},
});

export function PageContextProvider({ children }) {
  const [pageContext, setPageContextRaw] = useState('');

  const setPageContext = useCallback((ctx) => {
    setPageContextRaw(ctx || '');
  }, []);

  return (
    <PageContext.Provider value={{ pageContext, setPageContext }}>
      {children}
    </PageContext.Provider>
  );
}

export function usePageContext() {
  return useContext(PageContext);
}

export default PageContext;
